import React from "react";
import {FormProvider, SubmitHandler, useForm, UseFormGetValues} from "react-hook-form";
import {SubmitErrorHandler} from "react-hook-form";

import {IPreferencesDefaultValues} from "../../../types/IPreferencesDefaultValues";

type SubmitHandlerType = (
    onValid: SubmitHandler<IPreferencesDefaultValues>,
    onInvalid?: SubmitErrorHandler<IPreferencesDefaultValues>
) => (e?: React.BaseSyntheticEvent) => Promise<void>;

interface IProps {
    defaultValues: IPreferencesDefaultValues | null;
    children: (handleSubmit: SubmitHandlerType, getValues?: UseFormGetValues<IPreferencesDefaultValues>) => React.ReactNode;
}

export const PreferencesFormProvider = (props: IProps) => {
    const formMethods = useForm({defaultValues: props.defaultValues || {}});

    return <FormProvider {...formMethods}>{props.children(formMethods.handleSubmit, formMethods.getValues)}</FormProvider>;
};
import React from "react";
import {FormProvider, SubmitHandler, useForm, UseFormGetValues} from "react-hook-form";
import {SubmitErrorHandler} from "react-hook-form";

import {IPreferencesDefaultValues} from "../../../types/IPreferencesDefaultValues";

type SubmitHandlerType = (
    onValid: SubmitHandler<IPreferencesDefaultValues>,
    onInvalid?: SubmitErrorHandler<IPreferencesDefaultValues>
) => (e?: React.BaseSyntheticEvent) => Promise<void>;

interface IProps {
    defaultValues: IPreferencesDefaultValues | null;
    children: (handleSubmit: SubmitHandlerType, getValues?: UseFormGetValues<IPreferencesDefaultValues>) => React.ReactNode;
}

export const PreferencesFormProvider = (props: IProps) => {
    const formMethods = useForm({defaultValues: props.defaultValues || {}});

    return <FormProvider {...formMethods}>{props.children(formMethods.handleSubmit, formMethods.getValues)}</FormProvider>;
};
